import { AxiosResponse } from 'axios';
import api from '../Api';

export async function me(): Promise<AxiosResponse> {
  return api.get('user/me');
}

export async function putMe(data: any): Promise<AxiosResponse> {
  return api.put('user/me', data);
}